<template>
    <div ref="elSegmentItem"
         :class="`el-segment__inner ${getItemValue() === selectedValue ? 'is-selected' : ''} ${disabled ? 'is-disabled' : ''}`">
        <label v-bind:html-for="getItemValue()">
            <input type="radio" class="el-segment-input" :name="groupId"
                :value="getItemValue()" 
                @change="() => onInputChange(getItemValue())" 
                :checked="getItemValue() === selectedValue" />
            <span>{{ getItemLabel() }}</span>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: [String, Object],
            default() { return {} }
        },
        label: {
            type: String,
            default() { return "" }
        },
        disabled: {
            type: Boolean,
            default() { return false }
        },
    },
    watch: {
        selectedValue(val) {
            this.customHightlight(val);
        },
    },
    computed: {     
        groupId(){
            return this.$parent.idGroup;
        },   
        selectedValue(){
            return this.$parent.value;
        },
    },
    mounted() {
        this.customHightlight(this.selectedValue)
    },
    methods: {
        onInputChange(value) {
            this.$parent.$emit('input', value);
        },
        customHightlight(value) {
            if (this.$refs.elSegmentItem && this.getItemValue() === value) {
                const activeEl = this.$refs.elSegmentItem;
                const itemActiveWidth = activeEl.offsetWidth;
                const itemActiveLeft = activeEl.offsetLeft;
                this.$parent.customHightlight({ left: itemActiveLeft, width: itemActiveWidth });
            }
        },
        getItemLabel() {
            let isString = (typeof this.label === 'string');
            if (isString) return  this.label;
            else return this.label.toString();
        },
        getItemValue() {
            let isString = (typeof this.value === 'string');
            if (isString) return this.value;
            else return JSON.stringify(this.value);
        }
    }
}
</script>